import {withStyles, withStylesCompose} from '@/hocs/withStyles';
import {Noop} from '@/hocs/noop';
import styles from './styles.module.scss';
/**
 * Used in order to bundle everything together with a single component.
 * We can use this hoc in order to align each element passed via flexbox properties, and avoid duplications.
 * */

const withFlexHolder = (Component = Noop) => withStyles(Component, styles, 'flex-holder');
const withFlexHolderSpaceBetween = (Component = Noop) =>
  withStylesCompose(Component, styles, ['flex-holder', 'flex-holder-space-between']);
const withFlexHolderHero = (Component = Noop) =>
  withStylesCompose(Component, styles, ['flex-holder', 'flex-holder-hero']);
const withRowStretch = (Component = Noop) => withStyles(Component, styles, 'row-stretch');

export {withFlexHolder, withFlexHolderSpaceBetween, withFlexHolderHero, withRowStretch};
